import { useQuery } from '@apollo/client/react'
import Spinner from '~/components/Spinner'
import { GQL_LEARNER_LOGINS } from '~/gql/users/learner-profile'
import TablePagination from '~/pages/backoffice/TablePagination'
import { useTableQuery } from '~/pages/backoffice/useTableQuery'
import ProfileLogins from './ProfileLogins'

/** Le journal des connexions de l'apprenant, chargé page par page (#242). */
function LearnerLogins({ userId }: { userId: string }) {
  const { page, pageSize, setPage, setPageSize, queryArgs } = useTableQuery()
  const { data: current, previousData } = useQuery(GQL_LEARNER_LOGINS, {
    variables: { userId, skip: queryArgs.skip, take: queryArgs.take },
    fetchPolicy: 'cache-and-network',
  })
  // La page précédente reste affichée pendant que la suivante charge : sans elle, le
  // pied de tableau disparaîtrait sous le clavier de qui vient de l'activer.
  const data = current ?? previousData
  if (!data) return <Spinner className="mx-auto size-6 text-muted-foreground" />

  const total = data.learnerLogins.total

  return (
    <ProfileLogins
      events={data.learnerLogins.events}
      footer={total > 0 && (
        <TablePagination page={page} pageSize={pageSize} total={total} onPageChange={setPage} onPageSizeChange={setPageSize} />
      )}
    />
  )
}

export default LearnerLogins
